import {Store} from '../models/store.model';
import {StoreRepository, StoreListFilters} from '../repository/StoreRepository';
import {Pagination} from '../../../Data/types/BaseResponse';
import {PAGINATION_CONFIG} from '../../../constants/appConfig';

export class GetAllStoresUseCase {
  constructor (private storeRepository: StoreRepository) {}

  async execute (page = 1, limit: number = PAGINATION_CONFIG.DEFAULT_PAGE_SIZE, filters?: StoreListFilters): Promise<{ items: Store[]; pagination?: Pagination }> {
    return this.storeRepository.getAll(page, limit, filters);
  }
}
